import 'tachyons/css/tachyons.css';
import '../layouts/custom.css';
import styled from 'styled-components'

const Divider = styled.hr.attrs({
    className: 'bb bw1',
  })`
  background:none;
  `; 
  
const SectionFeatured = styled.section.attrs({
    className: 'w-100-ns',
  })`
  background-color:#0D1625;
  `; 

const SectionWork = styled.section.attrs({
    className: ' ph0-ns pt6-ns pb5-ns w-100-ns bg--black1',
  })`
  &.bukalapak {
    background-color:#D21F4F;
  }
  &.skillshare{
    background-color:#18C5CB;
  }
  &.yors{
    background-color:#19D1C2;
  }
  &.news{
    background-color:#000;
  }
  &.etobee{
    background-color:#7A397C;
  }
  &.dribbble{
    background-color:#ea4c89;
  }
  &.stickearn{
    background-color:#503680;
  }
  `; 
  
const SectionOuter = styled.section.attrs({
    className: 'ph6-ns ph5-m ph4 w-100-ns mw9 center',
  })`
  `; 

const SectionOuterFull = styled.section.attrs({
    className: 'w-100-ns',
  })`
  `;   
  
const SectionContact = styled.section.attrs({
    className: 'ph6-ns w-50-ns w-100-m bg--black2',
  })`
  `; 

const SectionTestimonial = styled.section.attrs({
    className: 'w-50-ns w-100-m w-100 fr ph6-ns pv5-ns ph5-m pv5-m ph4 pb4',
  })`
  `;   

const SectionFeaturedWork = styled.section.attrs({
    className: 'pl0-ns pl0-m pl0',
  })`
  display: flex;
  min-width: 100%;
  overflow-x: auto; 
  overflow-y: hidden;
  `;   

const Nav = styled.nav.attrs({
    className: 'db-ns dn dn-m dt-l w-100 ph6-ns pt4 pb3 absolute z-3',
  })`
  `;  
  
const NavMobile = styled.nav.attrs({
    className: 'db dn-ns db-m w-100 ph6-ns pt4 ph5-m pb3 absolute z-3 ph4',
  })`
  `;   
  
const NavLink = styled.ul.attrs({
    className: 'db dtc-l v-mid w-100 w-75-l tc tr-l sans-serif ttu fw6',
  })`
  `; 

const NavLinkList = styled.li.attrs({
    className: 'link dim-reverse dark-gray f7 f7-l dib ml4-ns ',
  })`
  `; 

const NavLinkMobile = styled.ul.attrs({
    className: 'db dtc-l v-mid w-100 tl sans-serif ttu fw6 ml0 mb3',
  })`
  `; 
  
  const NavLinkListMobile = styled.li.attrs({
    className: 'link dim-reverse dark-gray f7 f7-l dib mr3 pr2 mt3 mb1',
  })`
  &:last-child {margin-right:0px;}
  `;  
  

const FooterLink = styled.ul.attrs({
    className: 'f7 white sans-serif ml0 mb0',
  })`
  `; 
  
const FooterLinkList = styled.li.attrs({
    className: 'f7 white sans-serif di mr4-ns mr4 fl white shadow-0 no-underline fw5 o-50 dim-reverse',
  })`
  `; 

const SectionAboutHero = styled.section.attrs({
    className: 'ph6-ns ph0-m ph0 w-100-ns',
  })`
  background-color:#C1C1C8;
  `;   

const WorkList = styled.div.attrs({
    className: 'w-100-ns flex items-start mb5-ns mb5-m mb4 bb pb5-ns pb5-m pb4 b--grey3',
  })`
  &.next {
    margin-bottom:0;
    padding-bottom:0;
  }
  `; 
 
const WorkListEnd = styled.div.attrs({
    className: 'w-100-ns flex items-start bb mb5-ns pb5-ns pb0-m mb0-m pb0 mb5 b--grey3',
  })`
  &.next {
    margin-bottom:0;
    padding-bottom:0;
  }
  `;   

const WorkListLink = styled.a.attrs({
    className: '',
  })`

  `;

const WorkListClient = styled.div.attrs({
    className: 'w-50-ns w-100-m w-100 self-end tr-ns tl-m tl',
  })`
  `;   


export {Divider, SectionFeatured, SectionWork, SectionOuter, SectionOuterFull, SectionContact, SectionTestimonial, SectionFeaturedWork, NavLink, NavLinkList, FooterLink, FooterLinkList, SectionAboutHero, WorkList, WorkListClient, WorkListLink, WorkListEnd, Nav, NavMobile, NavLinkMobile, NavLinkListMobile}
